export const MARKETING_VERSION_PATTERN = /^\d+(?:\.\d+){1,3}$/;

export function versionPolicyConfirmation(action: "add" | "remove", version: string): string {
  return `${action === "add" ? "ADD" : "REMOVE"} ${version}`;
}

export function canRemoveAllowedVersion(allowedVersions: string[]): boolean {
  return allowedVersions.length > 1;
}
